import { useQuery } from '@tanstack/react-query';
import { reportService } from '../services/reportService';

// Compte les signalements non lus pour le badge de la sidebar. Pas de
// websocket dans l'app : on fait un polling léger (30s) plutôt que
// d'attendre un rechargement manuel.
export const useReportsUnreadCount = () => {
  const { data } = useQuery({
    queryKey: ['reports-unread-count'],
    queryFn: reportService.getUnreadCount,
    refetchInterval: 30000,
    refetchIntervalInBackground: false,
  });

  return data?.count ?? 0;
};
